import {Component} from '@angular/core';
import {MatButton} from "@angular/material/button";
import {MatDialogActions, MatDialogClose, MatDialogContent} from "@angular/material/dialog";
import {TranslatePipe} from "@ngx-translate/core";
import {MatError, MatFormField, MatLabel, MatPrefix} from '@angular/material/form-field';
import {MatIcon} from '@angular/material/icon';
import {FormControl, ReactiveFormsModule, Validators} from '@angular/forms';
import {MatInput} from '@angular/material/input';

@Component({
  selector: 'app-add-member',
  imports: [
    MatButton,
    MatDialogActions,
    MatDialogClose,
    MatDialogContent,
    TranslatePipe,
    MatFormField,
    MatIcon,
    ReactiveFormsModule,
    MatInput,
    MatLabel,
    MatPrefix,
    MatError
  ],
  templateUrl: './add-member.component.html',
  styleUrl: './add-member.component.scss'
})
export class AddMemberComponent {
  protected emailFormControl: FormControl = new FormControl('', [Validators.email]);

  onEnter() {
    if (this.emailFormControl.valid && this.emailFormControl.value) {
      this.emailFormControl.setErrors(null);
      document.getElementById('confirmation')?.click();
    } else {
      this.emailFormControl.setErrors({invalidEmail: true});
    }
  }
}
